import React, { memo } from "react"
import { EmptyNode as EmptyNodeType } from "@features/builder/graph/types"
import NodeContainer from "./NodeContainer"
import { Typography } from "@mui/material"

export const EmptyNode = memo((node: EmptyNodeType) => {
  return (
    <NodeContainer node={node} hideConnector>
      <div className="graph-node-container">
        <div className="graph-node-type">{node.type}</div>
        <div className="graph-node-label">{node.data.label}</div>
        <Typography
          color="error"
          sx={{ position: "absolute", bottom: 0, left: 15, fontSize: "5px" }}
        >
          Please select type of this node
        </Typography>
      </div>
    </NodeContainer>
  )
})

EmptyNode.displayName = "EmptyNode"
